import * as React from "react";
export var ButtonSize;
(function (ButtonSize) {
    ButtonSize["Small"] = "small";
    ButtonSize["Medium"] = "medium";
    ButtonSize["Big"] = "big";
})(ButtonSize || (ButtonSize = {}));
export var ButtonColor;
(function (ButtonColor) {
    ButtonColor["Primary"] = "primary";
    ButtonColor["Secondary"] = "secondary";
    ButtonColor["Negative"] = "negative";
    ButtonColor["Link"] = "link";
})(ButtonColor || (ButtonColor = {}));
class BaseButton extends React.PureComponent {
    render() {
        return (React.createElement("button", { type: "button", className: `rj-button rj-button--${this.props.size} rj-button--${this.props.color}`, "data-uat": this.props.dataUat, disabled: this.props.disabled, onClick: this.props.onClick },
            React.createElement("span", { className: "rj-button__inner" }, this.props.children)));
    }
}
export const Button = {
    Small: props => React.createElement(BaseButton, Object.assign({ size: ButtonSize.Small }, props)),
    Medium: props => React.createElement(BaseButton, Object.assign({ size: ButtonSize.Medium }, props)),
    Big: props => React.createElement(BaseButton, Object.assign({ size: ButtonSize.Big }, props))
};
//# sourceMappingURL=Button.js.map